import { type ReactElement, type ReactNode } from "react";
import { PostHogProvider } from "posthog-js/react";
import { initPostHogClient } from "@/zapi-frontend/app/providers/analytics/model/services";

export function AnalyticsProvider({ children }: { children: ReactNode }): ReactElement {
  const isLocalDev = window.location.href.includes("127.0.0.1") || window.location.href.includes("localhost");

  if (isLocalDev) return children as ReactElement;

  const instance = initPostHogClient();
  if (!instance) return children as ReactElement;

  return <PostHogProvider client={instance}>{children}</PostHogProvider>;
}
